import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { MAPAPIKEY } from '../constants'

const containerStyle = {
  width: "100%",
  height: "300px",
};

function MapComponent({ lat, lng, name }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAPAPIKEY,
  });

  const center = { lat, lng };

  const handleMarkerClick = () => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    window.open(mapsUrl, "_blank");
  };

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={14}>
      <Marker position={center} onClick={handleMarkerClick} title={name} />
    </GoogleMap>
  );
}

export default MapComponent;
